import base from './base'
import auth from './auth'
import smartSummary from './smartSummary'

const modules = {
  base,
  auth,
  smartSummary
}

export default modules
